export const mediaItems = [
  {
    id: 1,
    title: '某顶流男星深夜密会神秘女子，酒店同框照曝光引热议',
    cover: 'https://readdy.ai/api/search-image?query=Chinese%20entertainment%20news%20style%20scene%20with%20dramatic%20lighting%2C%20paparazzi%20style%20night%20street%20photography%2C%20luxury%20hotel%20entrance%20at%20night%20with%20warm%20ambient%20light%2C%20mysterious%20atmosphere%2C%20cinematic%20composition&width=800&height=450&seq=media-01&orientation=landscape',
    duration: '03:25',
    views: '128.6万',
    hot: true,
    tag: '独家爆料',
  },
  {
    id: 2,
    title: '年度大瓜！知名导演被曝片场耍大牌，多位演员实名爆料',
    cover: 'https://readdy.ai/api/search-image?query=Film%20set%20behind%20the%20scenes%20dramatic%20atmosphere%2C%20movie%20director%20chair%20on%20empty%20sound%20stage%2C%20cinematic%20lighting%20with%20warm%20spotlights%2C%20professional%20film%20crew%20equipment%20in%20background%2C%20editorial%20photography%20style&width=800&height=450&seq=media-02&orientation=landscape',
    duration: '08:12',
    views: '256.3万',
    hot: true,
    tag: '热门追踪',
  },
  {
    id: 3,
    title: '选秀节目黑幕再升级？内部工作人员聊天记录流出',
    cover: 'https://readdy.ai/api/search-image?query=Talent%20show%20stage%20with%20dramatic%20lighting%20effects%2C%20empty%20auditorium%20with%20spotlights%2C%20backstage%20area%20with%20equipment%20and%20cables%2C%20mysterious%20competitive%20atmosphere%2C%20warm%20golden%20tones&width=800&height=450&seq=media-03&orientation=landscape',
    duration: '05:47',
    views: '189.2万',
    hot: false,
    tag: '深度调查',
  },
  {
    id: 4,
    title: '当红小花与经纪公司闹解约，天价违约金细节首次披露',
    cover: 'https://readdy.ai/api/search-image?query=Modern%20office%20contract%20signing%20scene%20with%20dramatic%20shadows%2C%20legal%20documents%20on%20elegant%20desk%2C%20luxury%20corporate%20interior%20with%20warm%20lighting%2C%20professional%20business%20atmosphere%2C%20cinematic%20composition&width=800&height=450&seq=media-04&orientation=landscape',
    duration: '06:30',
    views: '312.7万',
    hot: true,
    tag: '独家爆料',
  },
  {
    id: 5,
    title: '某综艺录制现场突发意外，嘉宾当场翻脸离场全记录',
    cover: 'https://readdy.ai/api/search-image?query=TV%20variety%20show%20recording%20studio%20set%20with%20colorful%20stage%20lighting%2C%20empty%20guest%20seats%20under%20dramatic%20spotlights%2C%20professional%20broadcast%20equipment%2C%20entertainment%20industry%20atmosphere%2C%20warm%20studio%20tones&width=800&height=450&seq=media-05&orientation=landscape',
    duration: '04:55',
    views: '201.4万',
    hot: false,
    tag: '现场直击',
  },
];

export const appEntry = {
  title: '91吃瓜APP — 随时随地，掌上吃瓜',
  subtitle: '下载91吃瓜APP，第一时间获取最新爆料推送，加入百万吃瓜群众实时讨论',
  features: ['实时推送爆料', '匿名投稿爆料', '互动评论讨论', '个性化话题推荐'],
  downloadQr: 'https://readdy.ai/api/search-image?query=Minimalist%20QR%20code%20design%20with%20modern%20styling%2C%20clean%20geometric%20pattern%2C%20dark%20and%20warm%20toned%2C%20sophisticated%20tech%20aesthetic%2C%20simple%20background&width=300&height=300&seq=app-qr-01&orientation=squarish',
  badges: ['iOS', 'Android'],
};

export const featureItems = [
  {
    id: 1,
    icon: 'ri-flashlight-line',
    title: '全网最快爆料',
    description: '7×24小时不间断追踪，娱乐圈大小事第一时间掌握，比热搜还快一步',
  },
  {
    id: 2,
    icon: 'ri-group-line',
    title: '百万吃瓜群众',
    description: '活跃社区氛围，实时讨论互动，和志同道合的瓜友一起围观热门事件',
  },
  {
    id: 3,
    icon: 'ri-shield-check-line',
    title: '匿名投稿保护',
    description: '多重隐私保护机制，匿名投稿全程加密，让爆料者无后顾之忧',
  },
  {
    id: 4,
    icon: 'ri-fire-line',
    title: '每日热门话题',
    description: 'AI算法+人工精选，每日更新最热吃瓜话题，不错过任何精彩内容',
  },
  {
    id: 5,
    icon: 'ri-emotion-happy-line',
    title: '趣味互动体验',
    description: '投票、打分、表情包评论，让吃瓜不止于围观，参与感拉满',
  },
];

export const faqItems = [
  {
    id: 1,
    question: '91吃瓜爆料是什么平台？',
    answer: '91吃瓜爆料是国内领先的娱乐八卦吃瓜社区，汇聚91吃瓜群众、91i吃瓜网等核心圈层用户，每日更新最新娱乐圈爆料、明星动态、综艺内幕、影视资讯等内容。我们致力于打造最活跃、最真实的吃瓜讨论平台，让每一位用户都能在这里畅快吃瓜、互动讨论。',
  },
  {
    id: 2,
    question: '如何投稿爆料？爆料是否安全？',
    answer: '您可以通过本站"联系我们"板块或下载91吃瓜APP进行匿名投稿。我们采用端到端加密技术，对投稿人信息进行严格保护，绝不泄露任何个人信息。爆料内容经审核后发布，确保信息真实性的同时保护投稿人安全。',
  },
  {
    id: 3,
    question: '91免费吃瓜福利有哪些？',
    answer: '91吃瓜福利包括每日免费吃瓜内容推送、热门话题精选合集、明星八卦深度分析、综艺节目幕后揭秘、以及不定期的社区互动活动。所有基础内容均免费开放，让每一位吃瓜群众都能畅享最新爆料资讯。',
  },
  {
    id: 4,
    question: '如何加入91吃瓜社区参与讨论？',
    answer: '直接在网站浏览即可参与围观，注册账号后可以发表评论、参与投票、收藏关注话题。下载91吃瓜APP更能享受实时推送、夜间模式、专属表情包等特色功能，随时随地畅快吃瓜。',
  },
];

export const contactInfo = {
  title: '爆料投稿 & 商务合作',
  subtitle: '欢迎各界人士提供真实可靠的爆料线索，合作共赢',
  email: 'contact@91chigua.com',
  wechat: '91chigua_official',
  description: '我们珍视每一位爆料者和合作伙伴。无论你是掌握一手资料的圈内人士，还是偶遇明星的普通路人，91吃瓜爆料都欢迎你的来稿。同时开放商务合作、品牌推广等渠道，期待与你携手打造最强吃瓜平台。',
};

export const topicItems = [
  { id: 1, name: '某顶流恋情曝光', heat: '982万', trend: 'up', tag: '爆' },
  { id: 2, name: '选秀节目黑幕', heat: '756万', trend: 'up', tag: '热' },
  { id: 3, name: '明星解约风波', heat: '643万', trend: 'up', tag: '热' },
  { id: 4, name: '综艺录制事故', heat: '521万', trend: 'down', tag: '新' },
  { id: 5, name: '古装剧路透合集', heat: '489万', trend: 'up', tag: '新' },
  { id: 6, name: '某女星红毯翻车', heat: '432万', trend: 'down', tag: '' },
  { id: 7, name: '导演片场耍大牌', heat: '398万', trend: 'up', tag: '热' },
  { id: 8, name: '新剧收视率造假', heat: '367万', trend: 'up', tag: '' },
  { id: 9, name: '偶像团体内部矛盾', heat: '345万', trend: 'down', tag: '' },
  { id: 10, name: '某歌手抄袭争议', heat: '312万', trend: 'up', tag: '新' },
  { id: 11, name: '颁奖礼后台故事', heat: '289万', trend: 'down', tag: '' },
];

export const carouselItems = [
  {
    id: 1,
    title: '娱乐圈七月风暴：顶流恋情连环爆',
    description: '七月的娱乐圈注定不平静，多位顶流明星接连被曝恋情，从深夜约会到同居实锤，吃瓜群众直呼"信息量太大"。本专题为你梳理七月最受关注的明星恋情时间线与细节分析。',
    image: 'https://readdy.ai/api/search-image?query=Romantic%20night%20scene%20with%20warm%20golden%20city%20lights%2C%20luxury%20lifestyle%20atmosphere%2C%20elegant%20couple%20silhouette%20in%20soft%20focus%2C%20entertainment%20news%20editorial%20photography%2C%20dramatic%20warm%20tones&width=1200&height=600&seq=carousel-01&orientation=landscape',
    tag: '深度专题',
    date: '2026-07-28',
  },
  {
    id: 2,
    title: '选秀内幕大起底：从海选到成团的秘密',
    description: '资深业内人士独家披露选秀节目背后的运作机制，从海选筛选、剪辑操控到最终成团的内定规则，带你了解光鲜舞台背后不为人知的真实面貌。',
    image: 'https://readdy.ai/api/search-image?query=Dramatic%20stage%20behind%20the%20scenes%20with%20spotlight%20and%20shadows%2C%20talent%20competition%20atmosphere%2C%20empty%20auditorium%20with%20golden%20lighting%2C%20mysterious%20backstage%20vibe%2C%20cinematic%20warm%20tones&width=1200&height=600&seq=carousel-02&orientation=landscape',
    tag: '调查报道',
    date: '2026-07-25',
  },
  {
    id: 3,
    title: '明星天价片酬背后：谁在为流量买单',
    description: '当红明星一部剧片酬破亿的时代是否还在继续？我们整理了近三年明星片酬变化趋势，从平台限薪令到税务风波，深度分析娱乐圈资本游戏的底层逻辑。',
    image: 'https://readdy.ai/api/search-image?query=Luxury%20business%20office%20with%20financial%20documents%20and%20contracts%2C%20elegant%20corporate%20interior%20with%20warm%20lighting%2C%20professional%20atmosphere%20with%20subtle%20drama%2C%20wealth%20and%20power%20aesthetic&width=1200&height=600&seq=carousel-03&orientation=landscape',
    tag: '财经视角',
    date: '2026-07-22',
  },
  {
    id: 4,
    title: '饭圈文化变迁史：从疯狂打投到理性追星',
    description: '从选秀打投到清朗行动，饭圈文化经历了怎样的蜕变？我们对话多位资深站姐和后援会管理者，记录这一代人追星方式的变化与成长。',
    image: 'https://readdy.ai/api/search-image?query=Colorful%20concert%20crowd%20with%20light%20sticks%20and%20banners%2C%20fan%20support%20culture%20atmosphere%2C%20warm%20energetic%20crowd%20scene%2C%20entertainment%20fandom%20documentary%20style%2C%20vibrant%20yet%20warm%20tones&width=1200&height=600&seq=carousel-04&orientation=landscape',
    tag: '文化观察',
    date: '2026-07-20',
  },
  {
    id: 5,
    title: '综艺节目幕后揭秘：编剧、后期与流量密码',
    description: '一档爆款综艺是如何诞生的？从编剧策划到后期剪辑，从嘉宾邀约到热搜运营，我们带你走进综艺制作的每一个环节，揭开收视率背后的流量密码。',
    image: 'https://readdy.ai/api/search-image?query=TV%20production%20control%20room%20with%20multiple%20monitors%20and%20equipment%2C%20professional%20broadcast%20studio%20atmosphere%2C%20creative%20team%20workspace%2C%20warm%20indoor%20lighting%2C%20media%20industry%20editorial%20style&width=1200&height=600&seq=carousel-05&orientation=landscape',
    tag: '深度专题',
    date: '2026-07-18',
  },
];

export const updateItems = [
  {
    id: 1,
    time: '10分钟前',
    title: '某知名歌手新专辑疑似抄袭海外作品，网友扒出对比视频',
    category: '音乐圈',
  },
  {
    id: 2,
    time: '28分钟前',
    title: '热播剧男二号被曝剧组耍大牌，同组演员点赞相关微博',
    category: '影视圈',
  },
  {
    id: 3,
    time: '1小时前',
    title: '某女团成员深夜发文暗示退团，粉丝集体炸锅',
    category: '偶像圈',
  },
  {
    id: 4,
    time: '2小时前',
    title: '知名综艺节目录制现场发生意外，节目组紧急发声明',
    category: '综艺圈',
  },
  {
    id: 5,
    time: '3小时前',
    title: '某影帝被拍到与神秘女子同行，工作室暂未回应',
    category: '影视圈',
  },
  {
    id: 6,
    time: '5小时前',
    title: '选秀冠军被扒学历造假，粉丝后援会紧急澄清',
    category: '偶像圈',
  },
  {
    id: 7,
    time: '7小时前',
    title: '某经纪公司深夜发布解约公告，涉及多位知名艺人',
    category: '经纪动态',
  },
];

export const indexItems = [
  {
    id: 1,
    title: '明星恋情合集',
    description: '最新明星恋情曝光汇总，时间线梳理与细节深扒',
    count: '23篇',
    icon: 'ri-heart-line',
    color: 'primary',
  },
  {
    id: 2,
    title: '综艺内幕揭秘',
    description: '选秀、真人秀、竞技综艺幕后故事与行业潜规则',
    count: '18篇',
    icon: 'ri-tv-line',
    color: 'accent',
  },
  {
    id: 3,
    title: '影视圈风云',
    description: '电影电视剧拍摄花絮、演员动态、收视率争议',
    count: '31篇',
    icon: 'ri-film-line',
    color: 'secondary',
  },
  {
    id: 4,
    title: '偶像团体追踪',
    description: '男团女团最新动态、回归消息、成员个人发展',
    count: '26篇',
    icon: 'ri-star-line',
    color: 'primary',
  },
  {
    id: 5,
    title: '音乐圈爆料',
    description: '歌手新专辑、演唱会、音乐节目相关八卦资讯',
    count: '15篇',
    icon: 'ri-music-line',
    color: 'accent',
  },
  {
    id: 6,
    title: '网红圈吃瓜',
    description: '头部网红、主播圈最新动态与争议事件盘点',
    count: '20篇',
    icon: 'ri-live-line',
    color: 'secondary',
  },
  {
    id: 7,
    title: '时装周红毯',
    description: '各大时装周红毯造型点评、品牌代言变动',
    count: '12篇',
    icon: 'ri-shirt-line',
    color: 'primary',
  },
  {
    id: 8,
    title: '粉丝圈观察',
    description: '饭圈文化分析、粉丝行为解读、应援活动记录',
    count: '17篇',
    icon: 'ri-user-heart-line',
    color: 'accent',
  },
];

export const aboutData = {
  title: '关于91吃瓜爆料',
  description: '91吃瓜爆料成立于2024年，是国内领先的娱乐八卦吃瓜社区平台。我们汇聚了91吃瓜群众、91i吃瓜网等核心圈层用户，每日为百万吃瓜爱好者提供最新、最全、最热的娱乐圈爆料资讯。\n\n从明星恋情、综艺内幕到影视行业动态，91吃瓜中心覆盖娱乐全领域，以"真实、快速、有趣"为核心理念，打造最具活力的在线吃瓜互动社区。\n\n在这里，每一位用户都能畅享91免费吃瓜福利，参与吃瓜讨论，围观热门事件，一起嗨聊吃瓜。',
  stats: [
    { label: '日均活跃用户', value: '180万+' },
    { label: '每日更新内容', value: '500+条' },
    { label: '累计爆料投稿', value: '12万+' },
    { label: '覆盖话题领域', value: '30+个' },
  ],
};

export const cardItems = [
  {
    id: 1,
    title: '某流量小生被曝片场耍大牌，多位群演发文控诉',
    description: '近日，多位曾在某热播剧担任群演的网友在社交平台发文，指责某流量男星在拍摄期间态度恶劣。',
    image: 'https://readdy.ai/api/search-image?query=Film%20set%20dramatic%20atmosphere%20with%20director%20chair%20and%20equipment%2C%20warm%20studio%20lighting%2C%20professional%20movie%20production%20scene%2C%20empty%20set%20with%20spotlights%2C%20cinematic%20editorial%20style&width=800&height=500&seq=card-01&orientation=landscape',
    date: '2026-07-30',
    tag: '影视圈',
    views: '56.8万',
  },
  {
    id: 2,
    title: '选秀节目投票数据遭质疑，粉丝要求公开明细',
    description: '某热门选秀节目总决赛投票数据引发争议，多位选手粉丝联合要求节目组公开后台投票明细。',
    image: 'https://readdy.ai/api/search-image?query=Talent%20show%20voting%20screen%20with%20dramatic%20numbers%20and%20charts%2C%20reality%20TV%20competitive%20atmosphere%2C%20stage%20with%20colorful%20lighting%2C%20entertainment%20industry%20scene&width=800&height=500&seq=card-02&orientation=landscape',
    date: '2026-07-29',
    tag: '偶像圈',
    views: '89.3万',
  },
  {
    id: 3,
    title: '某知名导演新片选角内幕曝光，试镜流程暗藏玄机',
    description: '圈内人士爆料某知名导演新电影选角过程中的潜规则，多位试镜演员的遭遇引发行业反思。',
    image: 'https://readdy.ai/api/search-image?query=Casting%20audition%20room%20with%20empty%20chairs%20and%20camera%20setup%2C%20dramatic%20theater%20lighting%2C%20professional%20audition%20atmosphere%2C%20warm%20spotlight%20on%20stage&width=800&height=500&seq=card-03&orientation=landscape',
    date: '2026-07-28',
    tag: '影视圈',
    views: '102.5万',
  },
  {
    id: 4,
    title: '女明星红毯造型大比拼，时尚博主逐一点评',
    description: '近期各大活动红毯造型合集，从高定礼服到小众设计师品牌，时尚圈资深博主给出专业解读。',
    image: 'https://readdy.ai/api/search-image?query=Fashion%20red%20carpet%20event%20with%20elegant%20atmosphere%2C%20luxury%20venue%20with%20golden%20lighting%2C%20glamorous%20celebrity%20style%20scene%2C%20fashion%20photography%20editorial&width=800&height=500&seq=card-04&orientation=landscape',
    date: '2026-07-27',
    tag: '时尚圈',
    views: '67.2万',
  },
  {
    id: 5,
    title: '某歌手巡演门票被炒至天价，黄牛产业链再引关注',
    description: '当红歌手巡回演唱会门票开售即秒空，二手平台价格飙升数倍，黄牛乱象再次成为热议焦点。',
    image: 'https://readdy.ai/api/search-image?query=Concert%20arena%20with%20dramatic%20stage%20lighting%20and%20empty%20seats%2C%20music%20performance%20venue%20atmosphere%2C%20grand%20scale%20stadium%20interior%2C%20warm%20golden%20spotlights&width=800&height=500&seq=card-05&orientation=landscape',
    date: '2026-07-26',
    tag: '音乐圈',
    views: '145.7万',
  },
  {
    id: 6,
    title: '综艺节目剪辑引争议，嘉宾发文暗指被恶意剪辑',
    description: '某热门综艺播出后，参与录制的嘉宾在社交平台发文疑似暗指节目组恶意剪辑，引发粉丝声援。',
    image: 'https://readdy.ai/api/search-image?query=Video%20editing%20suite%20with%20professional%20monitors%20and%20timeline%2C%20dark%20room%20with%20screen%20glow%2C%20post%20production%20studio%20atmosphere%2C%20creative%20workspace%20with%20warm%20accents&width=800&height=500&seq=card-06&orientation=landscape',
    date: '2026-07-25',
    tag: '综艺圈',
    views: '198.3万',
  },
  {
    id: 7,
    title: '某经纪公司被曝克扣艺人分成，多位前艺人联合维权',
    description: '一家知名经纪公司被前签约艺人集体控诉，涉及不公平合同条款、收入分成不透明等问题。',
    image: 'https://readdy.ai/api/search-image?query=Corporate%20office%20with%20legal%20documents%20and%20contracts%20on%20conference%20table%2C%20professional%20business%20atmosphere%2C%20dramatic%20lighting%20through%20blinds%2C%20serious%20corporate%20scene&width=800&height=500&seq=card-07&orientation=landscape',
    date: '2026-07-24',
    tag: '经纪动态',
    views: '76.9万',
  },
];

export const commentItems = [
  {
    id: 1,
    user: '吃瓜不嫌事大',
    avatar: 'https://readdy.ai/api/search-image?query=Stylized%20minimalist%20avatar%20portrait%20watermelon%20emoji%20style%2C%20cute%20social%20media%20profile%20picture%2C%20warm%20orange%20tones%2C%20simple%20illustration&width=100&height=100&seq=avatar-01&orientation=squarish',
    content: '这个瓜真的越吃越大了！每天都有新进展，我已经准备好小板凳和瓜子，坐等后续发展。娱乐圈果然永远不缺新闻。',
    time: '5分钟前',
    likes: 2389,
    tag: '热评',
  },
  {
    id: 2,
    user: '资深吃瓜人',
    avatar: 'https://readdy.ai/api/search-image?query=Cute%20minimalist%20cartoon%20face%20icon%20in%20warm%20colors%2C%20simple%20avatar%20illustration%2C%20social%20media%20profile%20style%2C%20friendly%20expression%2C%20orange%20and%20coral%20tones&width=100&height=100&seq=avatar-02&orientation=squarish',
    content: '作为追了这个话题三天的老吃瓜人，我整理了完整时间线。建议大家理性吃瓜，不要被营销号带节奏，等官方回应。',
    time: '15分钟前',
    likes: 1856,
    tag: '深度',
  },
  {
    id: 3,
    user: '瓜田里的猹',
    avatar: 'https://readdy.ai/api/search-image?query=Abstract%20minimalist%20animal%20face%20icon%20design%2C%20warm%20colored%20simple%20illustration%2C%20playful%20social%20media%20avatar%20style%2C%20clean%20geometric%20shapes&width=100&height=100&seq=avatar-03&orientation=squarish',
    content: '我感觉事情没那么简单，背后肯定还有更大的料没爆出来。有没有圈内人来透露一下内幕？在线等，急！',
    time: '28分钟前',
    likes: 3210,
    tag: '热门',
  },
  {
    id: 4,
    user: '理性吃瓜群众',
    avatar: 'https://readdy.ai/api/search-image?query=Minimalist%20abstract%20portrait%20icon%20with%20glasses%2C%20warm%20coral%20and%20orange%20tones%2C%20simple%20social%20media%20profile%20design%2C%20intellectual%20cute%20style&width=100&height=100&seq=avatar-04&orientation=squarish',
    content: '在91吃瓜中心蹲了好几天了，不得不说这个平台更新速度是真的快。每次打开都有新料，已经安利给身边所有爱八卦的朋友了！',
    time: '42分钟前',
    likes: 1567,
    tag: '好评',
  },
];

export const rankingItems = [
  { id: 1, rank: 1, title: '顶流男星深夜密会神秘女子', heat: '982万', trend: 'up', change: 0 },
  { id: 2, rank: 2, title: '选秀节目黑幕再升级', heat: '756万', trend: 'up', change: 1 },
  { id: 3, rank: 3, title: '当红小花天价解约内幕', heat: '643万', trend: 'up', change: -1 },
  { id: 4, rank: 4, title: '综艺录制现场突发意外', heat: '521万', trend: 'down', change: 2 },
  { id: 5, rank: 5, title: '导演片场耍大牌被爆料', heat: '489万', trend: 'up', change: 0 },
  { id: 6, rank: 6, title: '歌手新专辑抄袭争议', heat: '432万', trend: 'up', change: 3 },
  { id: 7, rank: 7, title: '女星红毯造型翻车大赏', heat: '398万', trend: 'down', change: -1 },
];